export const DOWNLOAD_ATTACHMENT_EVENT = "kayros:download-attachment";
export const ATTACHMENT_DOWNLOADED_EVENT = "kayros:attachment-downloaded";
export const DOWNLOAD_ATTACHMENTS_EVENT = "kayros:download-attachments";
export const ATTACHMENTS_DOWNLOADED_EVENT = "kayros:attachments-downloaded";

const errorMessage = (error) =>
  error && error.message ? error.message : String(error);

const attachmentIds = (detail) => {
  const ids = detail && detail.ids;
  if (!Array.isArray(ids)) return [];
  return ids.map((id) => (id == null ? "" : String(id))).filter(Boolean);
};

export const attachmentZipName = (name) => {
  const cleaned = String(name || "")
    .replace(/[\\/:*?"<>|]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return cleaned || "documents";
};

/**
 * Lets a screen download stored attachments by id, one file or one zip.
 * Access is checked by the download mutations, not here.
 */
export const bindDownloadAttachmentEvents = (
  doc,
  { download, downloadZip },
) => {
  if (!doc || !doc.addEventListener) return () => {};

  const onDownload = (event) => {
    const id = event && event.detail && event.detail.id;
    if (!id || !download) return;
    const notify = (detail) => {
      doc.dispatchEvent(
        new CustomEvent(ATTACHMENT_DOWNLOADED_EVENT, {
          detail: { id, ...detail },
        }),
      );
    };
    Promise.resolve()
      .then(() => download({ id }))
      .then((ok) => notify({ ok: ok !== false }))
      .catch((error) => notify({ ok: false, error: errorMessage(error) }));
  };

  const onDownloadZip = (event) => {
    const detail = event && event.detail;
    const ids = attachmentIds(detail);
    if (!ids.length || !downloadZip) return;
    const name = attachmentZipName(detail && detail.name);
    const notify = (result) => {
      doc.dispatchEvent(
        new CustomEvent(ATTACHMENTS_DOWNLOADED_EVENT, {
          detail: { ids, name, ...result },
        }),
      );
    };
    Promise.resolve()
      .then(() => downloadZip({ ids, name }))
      .then((ok) => notify({ ok: ok !== false }))
      .catch((error) => notify({ ok: false, error: errorMessage(error) }));
  };

  doc.addEventListener(DOWNLOAD_ATTACHMENT_EVENT, onDownload);
  doc.addEventListener(DOWNLOAD_ATTACHMENTS_EVENT, onDownloadZip);
  return () => {
    doc.removeEventListener(DOWNLOAD_ATTACHMENT_EVENT, onDownload);
    doc.removeEventListener(DOWNLOAD_ATTACHMENTS_EVENT, onDownloadZip);
  };
};
